import React, { useState } from "react";
import Menu from "./Menu";
import Categories from "./Categories";
import ProjectList from "./Data";
import "./projects.css";

const allCategories = [
	"all",
	...new Set(ProjectList.map((item) => item.category)),
];
const Projects = () => {
	const [menuItems, setMenuItems] = useState(ProjectList);
	const [categories, setCategories] = useState(allCategories);
	const filterItem = (category) => {
		if (category == "all") {
			setMenuItems(ProjectList);
			return;
		}

		const newItem = ProjectList.filter(
			(project) => project.category == category
		);
		setMenuItems(newItem);
	};
	return (
		<section className="projects section" id="projects">
			<h2 className="section__title">Projects</h2>
			<span className="section__subtitle">What I have coded</span>
			<Categories categories={categories} filterItem={filterItem} />
			<Menu projectList={menuItems} />
		</section>
	);
};

export default Projects;
